'use client';

export { default } from './MenuItem';
export * from './menuItemClasses';
export { default as menuItemClasses } from './menuItemClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/MenuItem/index.js
// module id = 493
// module chunks = 22